/**
 * Erros de `POST /orders/{id}/cancel`. Ver .claude/docs/frontend_order_cancellation.md, seção 3.
 */

export interface CancelOrderErrorBody {
  message: string;
  zendeskTicketId?: number;
}

interface ApiErrorLike {
  response?: {
    status?: number;
    data?: any;
  };
}

export function isOrderNotFoundError(error: unknown): boolean {
  return (error as ApiErrorLike)?.response?.status === 404;
}

/** 409 quando o pedido já tinha sido cancelado antes — nunca vem com `zendeskTicketId`. */
export function isOrderAlreadyCancelledError(error: unknown): CancelOrderErrorBody | null {
  const response = (error as ApiErrorLike)?.response;
  if (
    response?.status === 409 &&
    typeof response.data?.message === "string" &&
    response.data.message.includes("já foi cancelado")
  ) {
    return response.data as CancelOrderErrorBody;
  }
  return null;
}

/** Mensagem exibida no formulário de cancelamento quando a chamada falha. */
export function getCancelOrderErrorMessage(error: unknown): string {
  if (isOrderNotFoundError(error)) {
    return "Pedido não encontrado. Verifique se o link ainda é válido.";
  }
  const blocked = isOrderCancellationBlockedError(error);
  if (blocked?.message) {
    return blocked.message;
  }
  return "Não foi possível cancelar o pedido. Tente novamente.";
}

/**
 * 409 cobrindo "já foi enviado ao sistema externo" e "já existe retorno de processamento" —
 * a API não distingue os dois com um `code` (seção 3) e a UI trata ambos da mesma forma
 * (mensagem + `zendeskTicketId` opcional, seção 3.1), então um único predicado basta.
 */
export function isOrderCancellationBlockedError(error: unknown): CancelOrderErrorBody | null {
  const response = (error as ApiErrorLike)?.response;
  if (
    response?.status === 409 &&
    typeof response.data?.message === "string" &&
    !isOrderAlreadyCancelledError(error)
  ) {
    return response.data as CancelOrderErrorBody;
  }
  return null;
}
